<template>
    <div>
        <div class="w-full border-solid border-t-4 border-blue-700 rounded-t shadow-md">
            <div class="flex justify-between bg-white">
                <h2 class="text-xl p-4">Upcoming Sites</h2>
                <div class="flex items-center mr-4">
                    <select v-model="dueIn" class="form-select form-select-blue text-sm">
                        <option value="6">Due within 6 months</option>
                        <option value="12">Due within 1 year</option>
                        <option value="24">Due within 2 years</option>
                        <option value="60">Due within 5 years</option>
                    </select>
                </div>
            </div>
            <table v-if="filteredSites.length" class="w-full">
                <thead>
                    <th class="pl-4">Address</th>
                    <th class="text-center">Remaining</th>
                    <th class="text-center">Due In</th>
                    <th class="text-center">Utilization</th>
                </thead>
                <tbody>
                    <tr v-for="(site, siteIndex) in orderBy(filteredSites, 'lease_end_date')" :key="siteIndex">
                        <td class="pl-4 leading-normal">
                            <a v-bind:href="site.view_url">
                                <p class="font-semibold">{{ site.building.address_line_1 | truncate(20) }}</p>
                                <p class="text-sm">{{ site.building.city }}, {{ site.building.state }}  {{ site.building.postal_code | truncate(5) }}</p>
                            </a>
                        </td>
                        <td class="text-center">
                            <div class="badge badge-red">
                                <div class="flex items-baseline space-x-1">
                                    <span :data-originalvalue="site.shortened_remaining_lease_cost" class="is-shorthand-currency font-extrabold">${{ site.shortened_remaining_lease_cost }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="badge" :class="site.status_color">
                                <span class="text-base font-variant-all-small-caps">{{ site.due_in_text }}</span>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="badge" :class="site.utilization_color">
                                <div class="flex items-baseline space-x-1">
                                    <span class="font-extrabold">{{ site.utilization }}%</span>
                                    <span class="text-base font-variant-all-small-caps">Utilized</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="! filteredSites.length" class="mb-5 none-found">No Upcoming Sites</div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    
    export default {
        props: {
            sites: {
                type: Array,
                required: true
            },

            showClientInfo: {
                type: Boolean,
                default: true
            }
        },

        data: function () {
            return {
                allSites: this.sites,
                filteredSites: this.sites,
                dueIn: '24'
            }
        },

        watch: {
            dueIn() {
                this.filterSites();
            },

            sites() {
                this.allSites = this.sites;
                this.filteredSites = this.sites;
                this.filterSites();
            },
        },

        mounted() {
            this.filterSites();
        },

        methods: {
            filterSites() {
                this.filteredSites = this.allSites;

                this.filteredSites = this.filteredSites.filter(site => {
                    return moment(site.lease_end_date).isBefore(moment().add(this.dueIn, 'months'));
                });
            }
        }
    }
</script>
